import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type UserDetails = Pick<
  Types.User,
  | 'id'
  | 'givenName'
  | 'familyName'
  | 'email'
  | 'createdAt'
  | 'lastLoggedInAt'
  | 'status'
  | 'enabled'
> & { role: Pick<Types.Role, 'id' | 'name' | 'permissions'> };

export const UserDetails = gql`
  fragment UserDetails on User {
    id
    givenName
    familyName
    email
    createdAt
    lastLoggedInAt
    status
    enabled
    role {
      id
      name
      permissions
    }
  }
`;
